import React from 'react';
import { IconButtonAction } from './icon-button-action';
import { IconName } from '../constants';

export { IconButtonAction } from './icon-button-action';

export const ValidateButtonAction = props =>
  <IconButtonAction {...props} iconName={IconName.Accept} />;

export const CancelButtonAction = props =>
  <IconButtonAction {...props} iconName={IconName.Cancel} />;

